export default {
    title: 'O mne',
    me: 'Volám sa Roman Baďurík a som solution developer senior.<br/> Úspešne som študoval na Slovenskej Technickej Univerzite a mám viac ako 10 ročnú skúsenosť ako programátor a developer. Som otvorený novým výzvam a príležitostiam a zaujímam sa o najnovšie technológie.Efektívne a kvalitné spracovanie kódu je vždy mojou prioritou. V súčasnosti programujem vo vue.js, typescript, html5, scss, boostrap, node.js, MongoDB.',
    contact: 'V prípade akýchkoľvek otázok a ponúk ma môžete kontaktovať: <strong><a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a></strong>',
    version: 'Toto je STARTUP project verzie: 1.0, copyright 2021 Roman Baďurík',
    dataPolicy: {
        title: 'Data policy',
        text: 'Formátované dáta nie sú posielané na sever a nie sú ukladané do databázy'
    },
    privacyPolicy: {
        title: 'Súbory cookies',
        text: 'Cookies sú súbory s malým množstvom údajov, ktoré môžu obsahovať anonymný jedinečný identifikátor. Cookies sa odosielajú do vášho prehliadača z webových stránok a ukladajú sa na pevný disk vášho počítača. <br/>        Webové stránky JSON Formatter ich konkrétne používajú na zlepšenie používateľských skúseností zapamätaním si predvolieb. Môžete svojmu prehliadaču dať pokyn, aby odmietol všetky súbory cookie alebo aby uviedol, kedy sa súbor cookie odosiela.'
    },
    reportBug: {
        title: 'Hlásenie chýb',
        text: 'Ak narazíte na chybu alebo máte otázky alebo návrhy na vylepšenia, nahláste to na adrese <a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a>'
    },
    advertising: {
        title: 'Reklama',
        text: 'V prípade akýchkoľvek reklamných otázok nás prosím kontaktujte <a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a>.'
    }
}
